import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
import { faShippingFast } from "@jewlr/pro-light-svg-icons/faShippingFast"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import { Flex, FontAwesomeIcon, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { jewlr_t, IS_JEWLR } from "helpers/application"
import { showHolidayShipMethodPDP } from "helpers/holiday"

const HolidayTitle = styled(Typography).attrs((props) => ({
  fontSize: { _: "16px", tablet: "18px" },
  fontWeight: { _: "600", tablet: "500" },
  letterSpacing: { tablet: "-0.03em" },
  lineHeight: "20px",
  // color: "sale",
  // fontSize: { _: "16px", tablet: "18px" },
  // fontWeight: "700",
  // letterSpacing: { tablet: "-0.03em" },
  ...props,
}))``

const StyledTitle = styled(Typography).attrs((props) =>
  props.cutoffStyle
    ? {
        fontSize: { _: "16px", tablet: "18px" },
        fontWeight: { _: "600", tablet: "700" },
        letterSpacing: "-0.03em",
        lineHeight: "16px",
      }
    : {
        fontSize: { _: "16px", tablet: "18px" },
        fontWeight: { _: "600", tablet: "500" },
      }
)``

const InternalTitle = ({
  holidayDelivery,
  isAccessory,
  // minDeliveryDate,
  ship,
}) => {
  const holidayStyle = showHolidayShipMethodPDP && holidayDelivery
  const cutoffStyle = showHolidayShipMethodPDP && !holidayDelivery
  if (holidayStyle) {
    // const arriveBy =
    //   new Date(minDeliveryDate).getDate() ==
    //   new Date(sl.config.guaranteed_receive_date).getDate()
    const text =
      ship.view_type === "AVAILABLE_HOLIDAY"
        ? // ? ` Arrives ${arriveBy ? "By" : "Before"} ${
          `Arrives Before ${
            sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
          }`
        : `${
            sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
          } Shipping Info`
    // `${sl.config.guaranteed_holiday} ${jewlr_t("terms.Shipping")} Info`
    // const text = `${sl.config.guaranteed_holiday} Shipping Info`
    return (
      <Flex alignItems="center" justifyContent="center" mb="12px">
        {/* {false && (
          <Box
            as="img"
            height="20px"
            mr="4px"
            src={require("images/icons/tree.svg")}
            width="auto"
          />
        )} */}

        <FontAwesomeIcon
          color={{ _: "blackPrint", tablet: "sale" }}
          fontSize={{ _: "16px", tablet: "18px" }}
          icon={faFlowerTulip}
          mr={1}
          style={{ verticalAlign: "text-top" }}
        />

        {/* {holidayStyle ? (
          <FontAwesomeIcon
            color="sale"
            fontSize={{ _: "15px", tablet: "16px" }}
            icon={faFlowerTulip}
            mr={1}
          />
        ) : (
          <FontAwesomeIcon
            color={{ _: "greenDarker", tablet: "sale" }}
            fontSize={{ _: "16px", tablet: "18px" }}
            icon={faGift}
            mr={1}
            style={{ verticalAlign: "text-top" }}
          />
        )} */}

        {/* <FontAwesomeIcon
            color={{ _: "greenDarker", tablet: "sale" }}
            fontSize={{ _: "16px", tablet: "18px" }}
            icon={faGift}
            mr={1}
            style={{ verticalAlign: "text-top" }}
          /> */}

        {/* <Box
          as="img"
          height="20px"
          mr="4px"
          src={require("images/icons/doublehearts_bold.svg")}
          width="auto"
        /> */}
        {/* <FontAwesomeIcon
          color="sale"
          height="14px"
          icon={faFlowerTulip}
          mr="4px"
          width="auto"
        /> */}
        {/* <Typography bold color="greenDarker" fontSize="18px"> */}
        <HolidayTitle color={{ _: "blackPrint", tablet: "sale" }}>
          {text}
        </HolidayTitle>
      </Flex>
    )
  }
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      mb={cutoffStyle ? { _: "22px", desktop: "10px" } : 1}
    >
      {IS_JEWLR() ? (
        <>
          <FontAwesomeIcon
            fontSize="18px"
            icon={faGift}
            style={{ marginRight: "4px", verticalAlign: "text-top" }}
          />
          <StyledTitle cutoffStyle={cutoffStyle}>
            {isAccessory
              ? `${jewlr_t("terms.Shipping")} Information`
              : "Custom made for you!"}
          </StyledTitle>
        </>
      ) : (
        <>
          <FontAwesomeIcon
            fontSize="22px"
            icon={faShippingFast}
            style={{ marginRight: "4px", verticalAlign: "text-top" }}
          />
          <StyledTitle>{jewlr_t("terms.Shipping")} Info</StyledTitle>
        </>
      )}
    </Flex>
  )
}

const mapStateToProps = (state) => {
  return {
    holidayDelivery: state.wizard.shipping.main?.available_holiday_delivery,
    isAccessory: state.wizard.description.product_type === "ACCESSORY",
    // minDeliveryDate: state.wizard.shipping.main?.min_delivery_date,
    ship: state.wizard.shipping.main,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalTitle.propTypes = {
  holidayDelivery: PropTypes.bool,
  isAccessory: PropTypes.bool,
  // minDeliveryDate: PropTypes.string,
  ship: PropTypes.object,
}

const Title = connect(mapStateToProps, mapDispatchToProps)(InternalTitle)

export default Title
